import { render } from "./GeneralSection.vue?vue&type=template&id=1018cb4d"
import script from "./GeneralSection.vue?vue&type=script&lang=js"
export * from "./GeneralSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/view/portfolio/sections/GeneralSection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1018cb4d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1018cb4d', __exports__)) {
    api.reload('1018cb4d', __exports__)
  }
  
  module.hot.accept("./GeneralSection.vue?vue&type=template&id=1018cb4d", () => {
    api.rerender('1018cb4d', render)
  })

}


export default __exports__